export const Link = {
  variants: {
    inline: {
      color: 'upgrade.blue.500',
      fontWeight: 600,
      textDecoration: 'underline',
      _hover: {
        color: 'upgrade.blue.700',
      },
    },
    external: {
      color: 'upgrade.blue.500',
      textDecoration: 'underline',
    },
    'inline-dark': {
      color: 'upgrade.blue.300',
      fontWeight: 600,
      textDecoration: 'underline',
    },
    'nav-link': {
      color: 'font.500',
      fontWeight: 'semibold',
      fontSize: 'sm',
      borderRadius: 'md',
      py: 1.5,
      px: 2,
      _hover: {
        textDecoration: 'none',
        bg: 'hover.gray',
      },
    },
    'nav-link-blue': {
      p: '10px 20px',
      textAlign: 'center',
      fontSize: '16px',
      color: 'upgrade.blue.500',
      background: 'none',
      fontWeight: 'normal',
      border: 'none',
      borderRadius: '4px',
      transition: 'background-color 0.3s',
      _hover: {
        backgroundColor: 'hover.blue',
        textDecoration: 'none',
        color: 'upgrade.blue.500',
      },
    },
    'infograph-nav-link': {
      color: 'font.500',
      fontSize: 'md',
      fontWeight: '400',
      borderRadius: 'md',
      py: 1.5,
      px: 2,
      _hover: {
        textDecoration: 'none',
        bg: 'hover.gray',
      },
    },
  },
};
